import { useState } from 'react'
import { Accordion, Col, Row } from 'react-bootstrap'
import styles from '@/components/page.module.scss'

const FrequentlyAskedQuestions = ({ data }) => {
	const [faqList, setFaqList] = useState([])
	const [activeAccordionText, setActiveAccordionText] = useState(-1)

	useState(() => {
		setFaqList(data)
	}, [])
	return (
		<div className='blog-related-content-container'>
			<Col className='mt-4'>
				<Row>
					<h2 className='faq-heading'>Frequently Asked Questions</h2>
				</Row>

				<Accordion defaultActiveKey={0}>
					{faqList?.map((arr, i) => (
						<Accordion.Item
							key={i}
							eventKey={i}
							className={`blog-faq-accordian rounded-3 ${activeAccordionText === i ? styles.activeAccordionText : ''}`}
							onClick={() => {
								setActiveAccordionText(i)
							}}
						>
							<Accordion.Header>
								<p className={`blog-faq-header ${activeAccordionText === i ? styles.activeAccordionHeader : ''}`}>{arr?.question}</p>
							</Accordion.Header>
							<Accordion.Body className='blog-faq-answer'>
								<p>{arr?.answer}</p>
							</Accordion.Body>
						</Accordion.Item>
					))}
				</Accordion>
			</Col>
		</div>
	)
}

export default FrequentlyAskedQuestions
